import { selectEditorSettingsData } from "../draft-selectors";
import { updateOrAddManyColumnTemplates } from "../helpers";
export const setColumnOptionSortOrderReducer = (state, action) => {
    for (const column of action.payload) {
        if (column && !column.sorted && column.sortOrderSequence && column.sortOrder) {
            column.sortOrderSequence = null;
            column.sortOrder = null;
        }
    }
    const data = selectEditorSettingsData(state);
    if (data?.columns?.options) {
        data.columns.options.forEach((c) => {
            const sortedItem = action.payload.find((p) => p.id === c.id);
            if (sortedItem) {
                c.sortOrder = sortedItem.sortOrder;
                c.sortOrderSequence = sortedItem.sortOrderSequence;
                c.sorted = sortedItem.sorted;
            }
            else {
                c.sortOrder = undefined;
                c.sortOrderSequence = undefined;
                c.sorted = false;
            }
        });
        updateOrAddManyColumnTemplates(state, data.columns.options);
    }
};
